/** The sign-in step piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { SignInStepEvents } from './contract';
import { SignInStepView } from './SignInStepView';
import { useSignInStep } from './useSignInStep';

export function SignInStep(props: PieceInput<SignInStepEvents>) {
  return <SignInStepView {...useSignInStep(props)} />;
}
